import React, { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useAppContext } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
import { getFilteredCategories } from '../ai/registry/categoryRegistry';

export default function LandingPage() {
  const navigate = useNavigate();
  const ctx = useAppContext();
  const { org, isSuperAdmin } = useAuth() || {};
  const toolResults = ctx?.toolResults;
  const selectedCategory = ctx?.selectedCategory;
  const setSelectedCategory = ctx?.setSelectedCategory;

  // Superadmins see all categories; orgs see only their licensed set
  const categories = useMemo(
    () => getFilteredCategories(isSuperAdmin ? null : org?.allowedCategories),
    [isSuperAdmin, org?.allowedCategories]
  );

  const handleCategoryClick = (catId) => {
    if (setSelectedCategory) setSelectedCategory(catId === selectedCategory ? null : catId);
    navigate('/search');
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 112px)',
        padding: '40px 24px',
      }}
    >
      <div style={{ maxWidth: 720, width: '100%', textAlign: 'center' }}>
        <h1 style={{ marginBottom: 10 }}>
          <span style={{ color: '#f43f5e', fontWeight: 700, fontSize: '2.6rem', display: 'block' }}>
            CrimsonScan
          </span>
          <span style={{ color: '#94a3b8', fontWeight: 300, fontSize: '1.4rem', letterSpacing: 3, textTransform: 'uppercase' }}>
            Spectra
          </span>
        </h1>
        <p style={{ color: '#94a3b8', fontSize: 17, marginBottom: 32, lineHeight: 1.6 }}>
          AI-powered materials discovery. Describe a target material in natural language — we generate, rank, analyze, and report.
        </p>

        {/* Category chips */}
        <div style={{ marginBottom: 36 }}>
          <p style={{ color: '#64748b', fontSize: 13, marginBottom: 12, textTransform: 'uppercase', letterSpacing: 1 }}>
            Start with a domain — or skip and type freely
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
            {categories.map(cat => {
              const isSelected = selectedCategory === cat.id;
              return (
                <button
                  key={cat.id}
                  title={cat.description}
                  onClick={() => handleCategoryClick(cat.id)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    padding: '7px 14px',
                    borderRadius: 20,
                    border: isSelected ? '1px solid #f43f5e' : '1px solid #334155',
                    background: isSelected ? 'rgba(244,63,94,0.12)' : '#0f1923',
                    color: isSelected ? '#f43f5e' : '#94a3b8',
                    fontSize: 13,
                    fontWeight: isSelected ? 600 : 400,
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span>{cat.icon}</span>
                  <span>{cat.label}</span>
                  {cat.domains.length > 1 && (
                    <span style={{ fontSize: 10, color: isSelected ? '#f43f5e' : '#475569', marginLeft: 2 }}>
                      ×{cat.domains.length}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
          <button
            className="btn btn-lg"
            style={{ minWidth: 260, fontWeight: 600, background: '#f43f5e', borderColor: '#f43f5e', color: '#fff' }}
            onClick={() => navigate('/search')}
          >
            ▶ Start Searching
          </button>

          {toolResults && (
            <button
              className="btn btn-outline-info btn-lg"
              style={{ minWidth: 260 }}
              onClick={() => navigate('/results')}
            >
              ↻ Continue Last Run
            </button>
          )}
        </div>

      </div>
    </div>
  );
}
